export default __webpack_public_path__ + "static/media/nc17.9112bd90.png";